import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/app/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScraperExperience","ScraperExperiencePanel","ScraperExperienceResults"] */ "/app/src/components/ScraperExperience.tsx");
